module.exports = __webpack_public_path__ + "img/discussion_bg.d13fa666.png";